module.exports = __webpack_public_path__ + "static/img/1.392e6af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/1.jpg
// module id = 6KWl
// module chunks = 0